import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesBomb: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.95 6.1H32v1.52h-3.05Zm0 4.57h1.52v1.52h-1.52Zm0-9.15h1.52v1.53h-1.52Zm-1.53 7.62h1.53v1.53h-1.53Zm0-6.09h1.53v1.52h-1.53ZM24.38 6.1h1.52v3.04h-1.52Zm0-6.1h1.52v3.05h-1.52ZM19.8 9.14h4.58v1.53H19.8Zm1.53-6.09h1.52v1.52h-1.52ZM19.8 1.52h1.53v1.53H19.8Zm-1.52 6.1h1.52v1.52h-1.52ZM16.76 6.1h1.52v1.52h-1.52Zm-4.57-1.53h4.57V6.1h-4.57Zm-1.53 4.57H7.61v3.05H4.57v1.52H3.04v1.53H1.52v3.05H0v6.09h1.52v3.05h1.52v1.52h1.53v1.53h3.04V32h7.62v-1.52h3.05v-1.53h1.52v-1.52h1.53v-3.05h1.52v-6.09h-1.52v-3.05H19.8v-1.53h-1.52v-1.52h-3.05V9.14h-3.04V6.1h-1.53Zm4.57 6.1h1.53v1.52h1.52v1.53h1.52v6.09h-1.52v-6.09h-1.52v-1.53h-1.53Zm0 10.66h1.53v1.53h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesBomb
